import { toUpper } from 'lodash';

// local dependencies
import { WIDGET_NAMES } from 'constants/entity-names';

// import views (components)
import { AuthFlowCallerIdentificationStep } from 'ui/containers/AuthFlowCallerIdentificationStep';
import { AuthFlowMemberVerificationStep } from 'ui/containers/AuthFlowMemberVerificationStep';
import { CheckoutPrescriptionInfo } from 'ui/containers/CheckoutPrescriptionInfo';
import { ShipppingAndPayment } from 'ui/containers/ShipppingAndPayment';
import { EpostInsuranceInformation } from 'ui/containers/EpostInsuranceInformation';
import { EpostAllergiesAndHealthConditions } from 'ui/containers/EpostAllergiesAndHealthConditions';
import { EpostPaymentInformationStep } from 'ui/containers/EpostPaymentInformationStep';
import { ReactivateEpostInsuranceInformationStep } from 'ui/containers/ReactivateEpostInsuranceInformationStep';
import { CheckoutConfirmOrder } from 'ui/containers/CheckoutConfirmOrder';

// import { MemberDetailsPayBalanceSelectCard } from 'ui/containers/MemberDetailsPayBalanceSelectCard';
// import { MemberDetailsPayBalanceSetAmount } from 'ui/containers/MemberDetailsPayBalanceSetAmount';

/*-------------*/

// default step view
const defaultStepView = ( props ) => toUpper( props.__text__ );

// set display name
defaultStepView.displayName = 'widgetsStepFlow.defaultStepView';

// set default props
defaultStepView.defaultProps = {
    __text__: 'DEFAULT_STEP_VIEW', // special prop
};

/*-------------*/

/**
 * @type {function}
 * @desc Resolvers are pure functions used for resolving templates (React components) or to transform some data.
 * A resolver function takes an `id` and an optional `payload` and returns a `result`.
 * Based on `switch` cases inside this function, correct `result` should be returned.
 * @param {object} payload
 * @example
 * import { getStepView } from 'resolvers/widgetsStepFlow';
 */
export const getStepView = ( name ) => {
    log.debug( 'widgetsStepFlow.getStepView()' );

    switch( name ) {

        // call authorization views
        case WIDGET_NAMES.AUTH_FLOW_CALLER_IDENTIFICATION: {
            return AuthFlowCallerIdentificationStep;
        }
        case WIDGET_NAMES.AUTH_FLOW_MEMBER_VERIFICATION: {
            return AuthFlowMemberVerificationStep;
        }

        // checkout steps
        case WIDGET_NAMES.PRESCRIPTION_INFO: {
            return CheckoutPrescriptionInfo;
        }
        case WIDGET_NAMES.SHIPPING_AND_PAYMENT_INFO: {
            return ShipppingAndPayment;
        }
        case WIDGET_NAMES.CONFIRM_ORDER: {
            return CheckoutConfirmOrder;
        }

        // //member details pay balance steps
        // case WIDGET_NAMES.MEMBER_DETAILS_PAY_BALANCE_SET_AMOUNT: {
        //     return MemberDetailsPayBalanceSetAmount;
        // }
        // case WIDGET_NAMES.MEMBER_DETAILS_PAY_BALANCE_SELECT_CARD: {
        //     return MemberDetailsPayBalanceSelectCard;
        // }
        
        case WIDGET_NAMES.INSURANCE_INFORMATION: {
            return EpostInsuranceInformation;
        }
        case WIDGET_NAMES.ALLERGIES_HEALTH_CONDITION: {
            return EpostAllergiesAndHealthConditions;
        }
        case WIDGET_NAMES.PAYMENT_INFORMATION: {
            return EpostPaymentInformationStep;
        }

        case WIDGET_NAMES.REACTIVATE_EPOST_INSURANCE_INFORMATION: {
            return ReactivateEpostInsuranceInformationStep;
        }

        /*-----------*/
        
        // return default view
        default: {
            return defaultStepView;
        }
    }
};
